var _desc, _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBinanceCurrency(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "256px",
    viewBox: "0 0 256 256",
    width: "256px",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null)), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    id: "Classic",
    stroke: "none",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#F3BA2F",
    id: "Binance-Coin",
    transform: "translate(-1570.000000, -2488.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1570.000000, 2488.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-3",
    points: "8.30912153 147.721013 48.4291093 147.721013 48.4291093 107.601025 8.30912153 107.601025",
    transform: "translate(28.369115, 127.661019) rotate(-45.000000) translate(-28.369115, -127.661019) "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-3",
    points: "206.892929 147.721013 247.012917 147.721013 247.012917 107.601025 206.892929 107.601025",
    transform: "translate(226.952923, 127.661019) rotate(-45.000000) translate(-226.952923, -127.661019) "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-3",
    points: "107.601025 147.721013 147.721013 147.721013 147.721013 107.601025 107.601025 107.601025",
    transform: "translate(127.661019, 127.661019) rotate(-45.000000) translate(-127.661019, -127.661019) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.826002,42.9100781 L182.826002,22.8500842 L72.4960362,22.8500842 L72.4960362,62.970072 L142.706015,62.970072 L142.706015,133.180051 L182.826002,133.180051 L182.826002,42.9100781 Z",
    id: "Combined-Shape",
    transform: "translate(127.661019, 78.015067) rotate(-45.000000) translate(-127.661019, -78.015067) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.826002,142.201982 L182.826002,122.141988 L72.4960362,122.141988 L72.4960362,162.261976 L142.706015,162.261976 L142.706015,232.471954 L182.826002,232.471954 L182.826002,142.201982 Z",
    id: "Combined-Shape",
    transform: "translate(127.661019, 177.306971) rotate(-225.000000) translate(-127.661019, -177.306971) "
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBinanceCurrency);
export default __webpack_public_path__ + "static/media/Binance_currency.de93f12ce14bedd27fb9a44b20eee12f.svg";
export { ForwardRef as ReactComponent };